import Grid2 from '@mui/material/Unstable_Grid2';
import { IntegrationNameWrapper, IntegrationStatusTagWrapper, LinkWrapper, LogoWrapper, PaperWrapper } from './styles';
import { Box } from '@mui/material';
import { IntegrationStatusType, StatusTag } from '../StatusTag';
import { useTranslation } from 'react-i18next';

export enum INTEGRATIONS {
  FACTORIAL = 'factorial',
  PERSONIO = 'personio',
  A3API = 'a3api', // no logo
  A3EQUIPO = 'a3equipo',
  FREEMATICA = 'freematica',
  SERESCO = 'seresco',
  NIVIMU = 'nivimu',
  IBERPER = 'iberper',
  DENARIO = 'denario',
  ATISA = 'atisa',
  SESAME = 'sesame',
  OFISIS = 'ofisis',
  SOFTLAND = 'softland',
  API = 'api', // no logo
  META4 = 'meta4',
  SAP = 'sap',
  SUMMAR_LABOR = 'summarLabor', // no logo + taken from the old pages
  SAGE = 'sage',
  CONECTIA_GPCN = 'conektiaGpcn', // no logo + taken from the old page
  CASTILLA = 'grupoCastillaEpsilon',
  TAMIGO = 'tamigo',
  KACTUS = 'kactus',
  SINERGY = 'sinergy',
  SIESA = 'siesa',
  BUK = 'buk',
  BIZNEO = 'bizneo',
  ENDALIA = 'endalia'
}

export enum INTEGRATIONS_V2 {
  FACTORIAL = 'factorial',
  A3API = 'a3api',
  PERSONIO = 'personio',
  CASTILLA = 'grupoCastillaEpsilon',
  BUK = 'buk',
  BIZNEO = 'bizneo'
}

type IntegrationButtonProps = {
  integrationName: INTEGRATIONS;
  isActive: boolean;
  isDisabled: boolean;
};

const getLogoSource = (integrationName: INTEGRATIONS) => {
  if (integrationName.includes(INTEGRATIONS.META4)) {
    return `/images/integrations/${INTEGRATIONS.META4}.png`;
  }

  return `/images/integrations/${integrationName}.png`;
};

export const IntegrationButton = ({ integrationName, isActive, isDisabled }: IntegrationButtonProps) => {
  const { t } = useTranslation('settings');
  return (
    <LinkWrapper to={`/settings/integrations/${integrationName}`} isDisabled={isDisabled}>
      <PaperWrapper variant="outlined" active={isActive} isDisabled={isDisabled} title={isActive ? 'active' : ''}>
        <Grid2 sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', height: '100%' }}>
          <Box alignItems="center" display="flex" flexGrow={1}>
            <LogoWrapper
              src={getLogoSource(integrationName)}
              onError={(e: React.SyntheticEvent<HTMLImageElement, Event>) => {
                e.currentTarget.src = '/images/integrations/default.png';
              }}
            />
          </Box>
          <Box
            display="flex"
            flexDirection="column"
            alignContent="center"
            justifyContent="center"
            flexWrap="wrap"
            flexGrow={1}
          >
            <Box>
              <IntegrationNameWrapper variant="body1">{t(`newTitle.${integrationName}`)}</IntegrationNameWrapper>
            </Box>
            {(isActive || isDisabled) && (
              <IntegrationStatusTagWrapper>
                <StatusTag status={isDisabled ? IntegrationStatusType.NOT_SUPPORTED : IntegrationStatusType.ACTIVE} />
              </IntegrationStatusTagWrapper>
            )}
          </Box>
        </Grid2>
      </PaperWrapper>
    </LinkWrapper>
  );
};
